import { Box } from "@mui/material";
import { PropsWithChildren } from "react";

import Container from "./Container";

const Main = ({ children }: PropsWithChildren) => (
  <Box
    sx={{
      background: "white",
    }}
  >
    <Container
      sx={{
        overflow: "hidden",
        paddingTop: "2em",
        paddingBottom: "3em",
      }}
    >
      {children}
    </Container>
  </Box>
);

export default Main;
